/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */
import { userReducerConstant } from '../../reducerConstant';
import { applicationUserManageReducerConstant } from '../../reducerConstant';
import { userManageReducerConstant } from '../../reducerConstant';
import { sessionStorageKey, stringConstant } from '../../../constant';
import { decryptData } from '../../../components/shared/helper';

const initialState = {
   userDetails: JSON.parse(decryptData(sessionStorageKey.USER_DETAILS)) ?? null,
   isLoading: false,
   errMsg: stringConstant.EMPTY,
   isLoaderactive: null,
   isPasswordUpdated: null,
   isSetPasswordLoaderactive: null,
   myProfile: null,
   isMyProfileUpdate: null,
   currentClientName: null,
   currentClientID: null,
   currentClientToken: null,
   userFeatures: null,
   featuresLoader: false,
   myProfileLoader: false,
   isSelectedClientLoader: false,
   validationMessage: stringConstant.EMPTY,
   isLogoutLoading: null,
   authError: null
};

const userReducer = (state = initialState, action = {}) => {
   switch (action.type) {
      case userReducerConstant.LOGIN_USER:
         return {
            ...state,
            isLoading: false,
            isPasswordUpdated: null,
            errMsg: stringConstant.EMPTY,
            userDetails: action.value.data
         };
      case userReducerConstant.SET_PASSWORD_LODER_SHOW:
         return {
            ...state,
            isSetPasswordLoaderactive: true
         };
      case userReducerConstant.SET_FEATURES_LOADER:
         return {
            ...state,
            featuresLoader: action.value
         };
      case userReducerConstant.FETCH_USER_MENU:
         return {
            ...state,
            userFeatures: action.value.data,
            featuresLoader: false
         };
      case userReducerConstant.USER_CLIENT_INFO:
         return {
            ...state,
            currentClientName: action.value.clientName,
            currentClientID: action.value.clientsGuid,
            currentClientToken: action.value.authToken
         };
      case userReducerConstant.CLIENT_SELECT_LOADER:
         return {
            ...state,
            isSelectedClientLoader: action.value,
         };
      case userReducerConstant.SET_UPDATE_MY_PROFILE:
         return {
            ...state,
            isMyProfileUpdate: action.value
         };
      case userReducerConstant.MY_PROFILE_LOADER:
         return {
            ...state,
            myProfileLoader: true
         };
      case userReducerConstant.FETCH_MY_PROFILE:
         const userDetails = state.userDetails;
         userDetails.userName = action.value.data.userName;
         return {
            ...state,
            myProfile: action.value.data,
            myProfileLoader: false,
            userDetails
         };
      case userReducerConstant.SET_PASSWORD_LODER_HIDE:
         return {
            ...state,
            isSetPasswordLoaderactive: false
         };
      case userReducerConstant.UPDATE_PASSWORD_SUCCESS:
         return {
            ...state,
            isPasswordUpdated: true
         };
      case userReducerConstant.UPDATE_PASSWORD_FAILURE:
         return {
            ...state,
            isPasswordUpdated: false
         };
      case userReducerConstant.TOGGLE_LOADER:
         return {
            ...state,
            isLoading: action.value
         };
      case userReducerConstant.SET_ERR_MSG:
         return {
            ...state,
            isLoading: false,
            errMsg: action.value
         };
      case userReducerConstant.LOADER_SHOW:
         return {
            ...state,
            isLoaderactive: true
         };
      case userReducerConstant.LODER_HIDE:
         return {
            ...state,
            isLoaderactive: false
         };
      case userReducerConstant.UPDATE_USERNAME:
         return {
            ...state,
            userDetails: action.value
         };
      case applicationUserManageReducerConstant.UPDATE_MY_ACCOUNT_USERNAME:
         const userUpdatedDetails = state.userDetails;
         userUpdatedDetails.userName = action.value;
         return {
            ...state,
            userDetails: userUpdatedDetails
         };
      case userManageReducerConstant.UPDATE_USER_MANAGEMENT_USERNAME:
         const userUpdatedDetail = state.userDetails;
         userUpdatedDetail.userName = action.value;
         return {
            ...state,
            userDetails: userUpdatedDetail
         };
      case userReducerConstant.VALIDATION_MESSAGE:
         return {
            ...state,
            validationMessage: action.value
         };
      case userReducerConstant.SET_LOGOUT_LOADER:
         return {
            ...state,
            isLogoutLoading: true
         };
      case userReducerConstant.REMOVE_LOGOUT_LOADER:
         return {
            ...state,
            isLogoutLoading: false
         };
      case userReducerConstant.SET_AUTH_ERROR:
         return {
            ...state,
            isLoading: false,
            authError: action.value
         };
      case userReducerConstant.CLEAR_AUTH_ERROR:
         return {
            ...state,
            authError: null
         };
      default:
         return state;
   }
};

export default userReducer;
